module.exports = __webpack_public_path__ + "media/images/flags/32/Commonwealth-c33040bc638c2c54abd8af4538071c11.png";